var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.linksTable = function (widget, chart, data, metadata) {
    MDB.Charts.emptyChartAndMakeVisible(widget, chart);
    chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget));
    
    var keys = !data[0] ? [] : Object.keys(data[0]);
    var table = $('<table class="table links-table"></table>');

    data.forEach(function (row) {
        var iconClass = row[keys[0]];
        var linkText = row[keys[1]];
        var linkUrl = keys.length === 4 ? row[keys[2]] : null;
        var tooltip = keys.length === 4 ? row[keys[3]] : null;

        var row = $('<tr />');
        var data = $('<td />');
        
        var content = $('<span />');

        if (linkUrl) {
            content = $('<a />', {
                href: linkUrl,
                target: '_blank'
            });
        }

        content.append(sprintf('<i class="fa fa-2x %s"></i> <span>%s</span>', iconClass, linkText));
        
        data.append(content);
        if (tooltip) {
            data.append(sprintf('<i class="fa fa-info-circle pull-right" data-toggle="tooltip" data-title="%s"></i>', tooltip));
        }

        data.appendTo(row);
        row.appendTo(table);
    });

    chart.append(table);
}